import React from 'react'
import { useAtomValue } from 'jotai'
import * as state from '../../states'

type INotificationProps = {
	text: React.ReactNode;
}
export const UiNotification = (props: INotificationProps) => {
	const { text } = props

	const isThemeDark = useAtomValue(state.themeIsDarkAtom)
	const bgColor = isThemeDark ? `var(--dangerColor)` : `rgba(255, 0, 0, 0.1)`
	const color = isThemeDark ? `var(--whiteColor)` : `rgba(255, 0, 0, 0.7)`

	return (
		<div className="p-3 rounded-3 text-center"
		     style={{ backgroundColor: bgColor }}
		>
			<h4 className="fs-16 fw-semibold d-block"
			    style={{ color: color, marginBottom: '0' }}
			>
				{text}
			</h4>
		</div>
	)
}